import React from 'react'
import { Field } from 'redux-form'
import { Checkbox } from 'semantic-ui-react'

const style = {
  display: 'block',
  marginBottom: 5,
}

const MultiCheckboxField = ({ input, className, label, disabled }) =>
  label.map((current, index) => (
    <Checkbox
      key={current}
      disabled={disabled}
      className={className}
      style={style}
      label={current}
      onChange={(_, { checked }) => {
        const valueToPickFrom = input.value
        const selected = valueToPickFrom[index] === '1'

        if (!selected) {
          if (checked) {
            input.onChange(`${valueToPickFrom.substr(0, index)}1${valueToPickFrom.substr(index + 1)}`)
          }
        } else if (!checked) {
          input.onChange(`${valueToPickFrom.substr(0, index)}2${valueToPickFrom.substr(index + 1)}`)
        }
      }}
      checked={input.value[index] === '1'}
    />
  ))

const DecoratedField = (props) => <Field {...props} component={MultiCheckboxField} />

export default DecoratedField
